import {FC, useEffect, useMemo, useState} from 'react'
import {KTSVG, QUERIES, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Booking} from '../../../modules/apps/booking/list/core/_models'
import {useQuery} from '@tanstack/react-query'
import {getLocations} from '../../../modules/apps/location/list/core/_requests'
import {getServices} from '../../../modules/apps/service/list/core/_requests'
import {GetCurrency} from '../../../../_component/CustomComponent'
import {ListLoading} from '../../../../_component/ListLoading'
import {getAvailabilitysByDate} from '../../../modules/apps/availability/list/core/_requests'
import dayjs from 'dayjs'
import {useAuth} from '../../../modules/auth'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {initialBooking} from '../../../modules/apps/booking/list/core/_models'
import {createBooking, getStaffs} from '../../../modules/apps/booking/list/core/_requests'
import {useThemeMode} from '../../../../_metronic/partials'
import {useIntl} from 'react-intl'
import {truncateString} from '../../../../_component/CustomFunctions'
import countries from '../../../../_component/countries.json'
import {
  PromotionCode,
  Taxrate,
  getTaxRates,
  verifyPromotionCode,
} from '../../../../_component/_request'

const bookingExtension = {
  payment_type: 'stripe',
  external: true,
  success_url: window.location.href,
  status: false,
  customer: {first_name: '', last_name: '', email: '', phone: '', country: '', state: ''},
  discount: undefined as number | undefined,
  tax_rate_id: undefined as string | undefined,
  promotion_code_id: undefined as number | undefined,
}
export const POS: FC<{defaultData?: Booking}> = ({defaultData}) => {
  const intl = useIntl()
  const [d, setD] = useState(defaultData)
  const {mode} = useThemeMode()
  const {currentUser, business} = useAuth()
  const [viewState, setViewState] = useState('location')
  const [tax, setTax] = useState<Taxrate>()
  const [summary, setSummary] = useState<Booking>({})
  const [code, setCode] = useState<string>()
  const [discount, setDiscount] = useState<PromotionCode>()
  const [verifying, setVerifying] = useState<boolean>(false)

  const {data: business_tax} = useQuery(
    [
      `${QUERIES.TAXRATES_LIST}-filter=${JSON.stringify({
        status: true,
        country: business?.BUSINESS_COUNTRY,
        state: business?.BUSINESS_STATE,
      })}`,
    ],
    () => {
      return getTaxRates(
        `filter=${JSON.stringify({
          status: true,
          country: business?.BUSINESS_COUNTRY,
          state: business?.BUSINESS_STATE,
        })}`
      )
    },
    {
      keepPreviousData: true,
    }
  )
  useEffect(() => {
    if (business_tax) {
      if (business_tax?.entities?.length) setTax(business_tax.entities[0])
    }
  }, [business_tax])

  const updateView = (view: string) => {
    if (view !== viewState) {
      document.getElementById(viewState + '_link')?.classList.remove('show')
      document.getElementById(viewState + '_link')?.classList.remove('active')
      document.getElementById(viewState)?.classList.remove('show')
      document.getElementById(viewState)?.classList.remove('active')
      document.getElementById(view + '_link')?.classList.add('show')
      document.getElementById(view + '_link')?.classList.add('active')
      document.getElementById(view)?.classList.add('show')
      document.getElementById(view)?.classList.add('active')
      setViewState(view)
    }
  }
  if (currentUser) {
    const customer = {
      first_name: currentUser.name.split(' ')[0],
      last_name: currentUser.name.split(' ')[1],
      email: currentUser.email,
      phone: '',
    }
    bookingExtension['customer'] = {...bookingExtension['customer'], ...customer}
  }
  const bookingSchema = Yup.object().shape({
    location_id: Yup.string().required().label('Location'),
    service_id: Yup.string().required().label('Service'),
    staff_id: Yup.string().required().label('Staff'),
    date: Yup.date().required().label('Date'),
    start_time: Yup.string().required().label('Start time'),
    end_time: Yup.string().label('End time'),
    description: Yup.string().label('Note'),
    customer: Yup.object({
      first_name: Yup.string().when([], {
        is: () => !currentUser,
        then: Yup.string().required().label('First name'),
      }),
      last_name: Yup.string().when([], {
        is: () => !currentUser,
        then: Yup.string().required().label('Last name'),
      }),
      email: Yup.string().when([], {
        is: () => !currentUser,
        then: Yup.string().required().label('Email'),
      }),
      phone: Yup.string().when([], {
        is: () => true,
        then: Yup.string().required().label('Phone'),
      }),
      country: Yup.string().when([], {
        is: () => true,
        then: Yup.string().required().label('Country'),
      }),
      state: Yup.string().when([], {
        is: () => true,
        then: Yup.string().required().label('State'),
      }),
    }),
  })
  const formik = useFormik({
    initialValues: {...initialBooking, ...bookingExtension, ...defaultData},
    validationSchema: bookingSchema,
    onSubmit: async (values) => {
      try {
        delete values.end_time1
        delete values.start_time1
        values.discount = charges.discount
        values.tax_rate_id = tax?.stripe_tax_rate_id
        values.promotion_code_id = discount?.id
        const response = await createBooking(values)
        if (response?.url) window.location.replace(response.url)
      } catch (err) {
        console.log(err)
      }
    },
  })
  const filter = useMemo(() => {
    const result: any = {status: true}
    if (formik.values.location_id) result.location_id = formik.values.location_id
    if (formik.values.service_id) result.service_id = formik.values.service_id
    if (formik.values.staff_id) result.staff_id = formik.values.staff_id
    return result
  }, [formik.values.location_id, formik.values.service_id, formik.values.staff_id])
  const {isFetching: locationLoading, data: location} = useQuery(
    [
      `${QUERIES.LOCATIONS_LIST}-filter={"status":true,"staff_id":"${formik.values.staff_id}","service_id":"${formik.values.service_id}"}`,
    ],
    () => {
      const f = {...filter}
      delete f.location_id
      const query = `filter=${JSON.stringify(f)}`
      return getLocations(query)
    },
    {
      keepPreviousData: true,
    }
  )
  const {isFetching: serviceLoading, data: service} = useQuery(
    [
      `${QUERIES.SERVICES_LIST}-filter={"status":true,"location_id":${formik.values.location_id},"staff_id":${formik.values.staff_id}}`,
    ],
    () => {
      const f = {...filter}
      delete f.servide_id
      const query = `filter=${JSON.stringify(f)}`
      return getServices(query)
    },
    {
      keepPreviousData: true,
    }
  )
  const {isFetching: staffLoading, data: staff} = useQuery(
    [
      `${QUERIES.SERVICE_LOCATIONS_LIST}-filter={"status":true,"location_id":${formik.values.location_id},"service_id":${formik.values.service_id}`,
    ],
    () => {
      const f = {...filter}
      delete f.staff_id
      const query = `filter=${JSON.stringify(f)}`
      return getStaffs(query)
    },
    {
      keepPreviousData: true,
    }
  )
  const {
    isFetching: availabilityLoading,
    isFetched: availabilityFetched,
    data: availability,
  } = useQuery(
    [
      `${QUERIES.SERVICE_LOCATIONS_LIST}-staff_id=${formik.values.staff_id}&date=${formik.values.date}`,
    ],
    () => {
      const query = `date=${formik.values.date}&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`
      return getAvailabilitysByDate(formik.values.staff_id!, query)
    },
    {
      keepPreviousData: true,
      enabled: !!formik.values.date && !!formik.values.staff_id,
    }
  )
  const timeslots = useMemo(() => {
    const result: any[] = []
    if (availability) {
      const duration = summary.service?.duration

      if (duration) {
        availability.time_slots.forEach((item) => {
          item.start = dayjs(item.start).format()
          item.end = dayjs(item.end).format()
          let new_end_time = dayjs(item.start).add(duration, 'm').format()
          let count = 0
          while (new_end_time <= item.end) {
            result.push({
              id: count,
              start: item.start,
              end: new_end_time,
            })
            item.start = new_end_time
            new_end_time = dayjs(new_end_time).add(duration, 'm').format()
            count++
          }
        })
      }
    }
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availability, summary.service])
  const charges = useMemo(() => {
    const result: {tax?: number; gross?: number; discount?: number} = {}
    if (summary.service?.charge) {
      result.gross = summary.service.charge
      result.discount = discount
        ? discount.coupon_type === 'percentage'
          ? (discount.coupon_value * result.gross) / 100
          : discount.coupon_value
        : 0
      result.gross -= result.discount
      result.tax = (result.gross * (tax?.percentage || 0)) / 100
      if (!tax?.inclusive) result.gross += result.tax
    }
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summary.service, tax, discount])

  const updateData = (field: string, value: any, dt: any, next_view?: string) => {
    formik.setFieldValue(field, value)
    const s: any = {}
    if (field !== 'start_time') s.start_time = undefined
    s[field.replace('_id', '')] = dt
    setSummary({...summary, ...s})
    next_view && updateView(next_view)
    setDiscount(undefined)
  }
  useEffect(() => {
    if (d?.service_id && service) {
      const res = service.entities?.find((s) => s.id === d.service_id)
      if (res) setSummary({...summary, service: res})
      setD(undefined)
    }
    if (d?.staff_id && staff) {
      const res = staff.entities?.find((s) => s.id === d.staff_id)
      if (res) setSummary({...summary, staff: res as any})
      setD(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [d, staff, service])
  const NoData = ({view}: {view: string}) => (
    <div className=' m-auto text-center'>
      There are no matching data for your selected option
      <button
        className='btn btn-primary btn-sm d-block m-auto my-5'
        onClick={() => updateView(view)}
      >
        Back
      </button>
    </div>
  )
  const verify = async () => {
    try {
      if (code) {
        setVerifying(true)
        const data: {code: string; amount?: number; email?: string} = {code}
        if (charges.gross) data.amount = charges.gross
        if (formik.values.customer?.email) data.email = formik.values.customer.email
        const pCode = await verifyPromotionCode(data)
        setDiscount(pCode)
      }
    } catch (error) {
      setDiscount(undefined)
    } finally {
      setVerifying(false)
    }
  }
  return (
    <div id='kt_app_content' className='app-content flex-column-fluid'>
      {/*begin::Content container*/}
      <div id='kt_app_content_container' className='app-container container-xxl'>
        {/*begin::Layout*/}
        <div className='d-flex flex-column flex-xl-row'>
          {/*begin::Content*/}
          <div className='d-flex flex-row-fluid me-xl-9 mb-10 mb-xl-0'>
            {/*begin::Pos food*/}
            <div className='card card-flush card-p-0 bg-transparent border-0'>
              {/*begin::Body*/}
              <div className='card-body'>
                {/*begin::Nav*/}
                <ul className='nav nav-pills d-flex justify-content-between nav-pills-custom d-grid gap-3 gap-lg-6 mb-6'>
                  {/*begin::Item*/}
                  <li className='nav-item mb-3 me-0'>
                    {/*begin::Nav link*/}
                    <button
                      onClick={() => updateView('location')}
                      id='location_link'
                      className='nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-primary flex-column flex-stack pt-9 pb-7 page-bg show active'
                      // data-bs-toggle='pill'
                      // href='#kt_pos_food_content_1'
                      style={{width: '138px', height: '180px'}}
                    >
                      {/*begin::Icon*/}
                      <div className='nav-icon mb-3'>
                        {/*begin::Food icon*/}
                        <KTSVG
                          path='/media/icons/duotune/ecommerce/ecm004.svg'
                          className='svg-icon-muted svg-icon-4hx'
                        />
                        {/* <img
                          src={toAbsoluteUrl('/media/icons/duotune/ecommerce/ecm004.svg')}
                          className='w-50px'
                          alt=''
                        /> */}
                        {/*end::Food icon*/}
                      </div>
                      {/*end::Icon*/}
                      {/*begin::Info*/}
                      <div className=''>
                        <span className='text-gray-800 fw-bold fs-2 d-block'>
                          {intl.formatMessage({id: 'Location'})}
                        </span>
                        <span className='text-gray-400 fw-semibold fs-7'>
                          {location?.total_count} options(s)
                        </span>
                      </div>
                      {/*end::Info*/}
                    </button>
                    {/*end::Nav link*/}
                  </li>
                  {/*end::Item*/}
                  {/*begin::Item*/}
                  <li className='nav-item mb-3 me-0'>
                    {/*begin::Nav link*/}
                    <button
                      onClick={() => updateView('service')}
                      id='service_link'
                      className='nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-primary flex-column flex-stack pt-9 pb-7 page-bg'
                      // data-bs-toggle='pill'
                      // href='#kt_pos_food_content_2'
                      style={{width: '138px', height: '180px'}}
                    >
                      {/*begin::Icon*/}
                      <div className='nav-icon mb-3'>
                        {/*begin::Food icon*/}
                        <KTSVG
                          path='/media/icons/duotune/ecommerce/ecm009.svg'
                          className='svg-icon-muted svg-icon-4hx'
                        />
                        {/*end::Food icon*/}
                      </div>
                      {/*end::Icon*/}
                      {/*begin::Info*/}
                      <div className=''>
                        <span className='text-gray-800 fw-bold fs-2 d-block'>
                          {intl.formatMessage({id: 'Service'})}
                        </span>
                        <span className='text-gray-400 fw-semibold fs-7'>
                          {service?.total_count} options(s)
                        </span>
                      </div>
                      {/*end::Info*/}
                    </button>
                    {/*end::Nav link*/}
                  </li>
                  {/*end::Item*/}
                  {/*begin::Item*/}
                  <li className='nav-item mb-3 me-0'>
                    {/*begin::Nav link*/}
                    <button
                      onClick={() => updateView('staff')}
                      id='staff_link'
                      className='nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-primary flex-column flex-stack pt-9 pb-7 page-bg'
                      // data-bs-toggle='pill'
                      // href='#kt_pos_food_content_3'
                      style={{width: '138px', height: '180px'}}
                    >
                      {/*begin::Icon*/}
                      <div className='nav-icon mb-3'>
                        {/*begin::Food icon*/}
                        <KTSVG
                          path='/media/icons/duotune/communication/com006.svg'
                          className='svg-icon-muted svg-icon-4hx'
                        />
                        {/* <img
                          src={toAbsoluteUrl('/media/svg/food-icons/cheeseburger.svg')}
                          className='w-50px'
                          alt=''
                        /> */}
                        {/*end::Food icon*/}
                      </div>
                      {/*end::Icon*/}
                      {/*begin::Info*/}
                      <div className=''>
                        <span className='text-gray-800 fw-bold fs-2 d-block'>
                          {intl.formatMessage({id: 'Staff'})}
                        </span>
                        <span className='text-gray-400 fw-semibold fs-7'>
                          {staff?.total_count} options(s)
                        </span>
                      </div>
                      {/*end::Info*/}
                    </button>
                    {/*end::Nav link*/}
                  </li>
                  {/*end::Item*/}
                  {/*begin::Item*/}
                  <li className='nav-item mb-3 me-0'>
                    {/*begin::Nav link*/}
                    <button
                      onClick={() => updateView('date')}
                      id='date_link'
                      className='nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-primary flex-column flex-stack pt-9 pb-7 page-bg'
                      // data-bs-toggle='pill'
                      // href='#kt_pos_food_content_4'
                      style={{width: '138px', height: '180px'}}
                    >
                      {/*begin::Icon*/}
                      <div className='nav-icon mb-3'>
                        {/*begin::Food icon*/}
                        <KTSVG
                          path='/media/icons/duotune/general/gen014.svg'
                          className='svg-icon-muted svg-icon-4hx'
                        />
                        {/*end::Food icon*/}
                      </div>
                      {/*end::Icon*/}
                      {/*begin::Info*/}
                      <div className=''>
                        <span className='text-gray-800 fw-bold fs-2 d-block'>Date</span>
                        <span className='text-gray-400 fw-semibold fs-7'>& Time</span>
                      </div>
                      {/*end::Info*/}
                    </button>
                    {/*end::Nav link*/}
                  </li>
                  <li className='nav-item mb-3 me-0'>
                    {/*begin::Nav link*/}
                    <button
                      onClick={() => updateView('user')}
                      id='user_link'
                      className='nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-primary flex-column flex-stack pt-9 pb-7 page-bg'
                      // data-bs-toggle='pill'
                      // href='#kt_pos_food_content_4'
                      style={{width: '138px', height: '180px'}}
                    >
                      {/*begin::Icon*/}
                      <div className='nav-icon mb-3'>
                        {/*begin::Food icon*/}
                        <KTSVG
                          path='/media/icons/duotune/ecommerce/ecm005.svg'
                          className='svg-icon-muted svg-icon-4hx'
                        />
                        {/* <img
                          src={toAbsoluteUrl('/media/svg/food-icons/coffee.svg')}
                          className='w-50px'
                          alt=''
                        /> */}
                        {/*end::Food icon*/}
                      </div>
                      {/*end::Icon*/}
                      {/*begin::Info*/}
                      <div className=''>
                        <span className='text-gray-800 fw-bold fs-2 d-block'>Checkout</span>
                        <span className='text-gray-400 fw-semibold fs-7'>User details</span>
                      </div>
                      {/*end::Info*/}
                    </button>
                    {/*end::Nav link*/}
                  </li>
                  {/*end::Item*/}
                </ul>
                {/*end::Nav*/}
                {/*begin::Tab Content*/}
                <div className='tab-content'>
                  {/*begin::Tap pane*/}
                  <div className='tab-pane fade show active' id='location'>
                    {/*begin::Wrapper*/}
                    <div className='d-flex flex-wrap d-grid gap-5 gap-xxl-9'>
                      {/*begin::Card*/}
                      {locationLoading && <ListLoading />}
                      {!locationLoading && !location?.entities?.length && (
                        <NoData view='location' />
                      )}
                      {location?.entities?.map((entity, i) => (
                        <div
                          onClick={() => updateData('location_id', entity.id, entity, 'service')}
                          className='card card-flush flex-row-fluid  flex-lg-row-auto p-6 pb-5 mw-100 cursor-pointer'
                          style={entity.id === formik.values.location_id ? {opacity: 0.5} : {}}
                          key={i}
                        >
                          {/*begin::Body*/}
                          <div className='card-body text-center'>
                            {/*begin::Food img*/}
                            <img
                              src={
                                entity.image_url
                                  ? process.env.REACT_APP_BUCKET_URL + '/' + entity.image_url
                                  : toAbsoluteUrl(
                                      `/media/svg/files/blank-image${
                                        mode === 'dark' ? '-dark' : ''
                                      }.svg`
                                    )
                              }
                              className='rounded-3 mb-4 w-150px h-150px w-xxl-200px h-xxl-200px'
                              alt=''
                            />
                            {/*end::Food img*/}
                            {/*begin::Info*/}
                            <div className='mb-2'>
                              {/*begin::Title*/}
                              <div className='text-center'>
                                <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-3 fs-xl-1'>
                                  {truncateString(entity.name!, 25)}
                                </span>
                                <span className='text-gray-400 fw-semibold d-block fs-6 mt-n1'>
                                  {entity.city ? entity.city + ',' : ''} {entity.state}
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Info*/}
                            {/*begin::Total*/}
                            {/* <span className='text-success text-end fw-bold fs-1'>$16.50$</span> */}
                            {/*end::Total*/}
                          </div>
                          {/*end::Body*/}
                        </div>
                      ))}
                      {/*end::Card*/}
                    </div>
                    {/*end::Wrapper*/}
                  </div>
                  {/*end::Tap pane*/}
                  {/*begin::Tap pane*/}
                  <div className='tab-pane fade' id='service'>
                    {/*begin::Wrapper*/}
                    <div className='d-flex flex-wrap d-grid gap-5 gap-xxl-9'>
                      {/*begin::Card*/}
                      {serviceLoading && <ListLoading />}
                      {!serviceLoading && !service?.entities?.length && <NoData view='location' />}
                      {service?.entities?.map((entity, i) => (
                        <div
                          onClick={() => updateData('service_id', entity.id, entity, 'staff')}
                          key={i}
                          className='card card-flush  flex-row-fluid flex-lg-row-auto p-6 pb-5 mw-100'
                          style={entity.id === formik.values.service_id ? {opacity: 0.5} : {}}
                        >
                          {/*begin::Body*/}
                          <div className='card-body text-center'>
                            {/*begin::Food img*/}
                            <img
                              src={
                                entity.image_url
                                  ? process.env.REACT_APP_BUCKET_URL + '/' + entity.image_url
                                  : toAbsoluteUrl(
                                      `/media/svg/files/blank-image${
                                        mode === 'dark' ? '-dark' : ''
                                      }.svg`
                                    )
                              }
                              className='rounded-3 mb-4 w-150px h-150px w-xxl-200px h-xxl-200px'
                              alt=''
                            />
                            {/*end::Food img*/}
                            {/*begin::Info*/}
                            <div className='mb-2'>
                              {/*begin::Title*/}
                              <div className='text-center'>
                                <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-3 fs-xl-1'>
                                  {truncateString(entity.name!, 25)}
                                </span>
                                <span className='text-gray-400 fw-semibold d-block fs-6 mt-n1'>
                                  {entity.duration} mins
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Info*/}
                            {/*begin::Total*/}
                            <span className='text-success text-end fw-bold fs-1'>
                              <GetCurrency value={entity.charge} />
                            </span>
                            {/*end::Total*/}
                          </div>
                          {/*end::Body*/}
                        </div>
                      ))}
                      {/*end::Card*/}
                    </div>
                    {/*end::Wrapper*/}
                  </div>
                  {/*end::Tap pane*/}
                  {/*begin::Tap pane*/}
                  <div className='tab-pane fade' id='staff'>
                    {/*begin::Wrapper*/}
                    <div className='d-flex flex-wrap d-grid gap-5 gap-xxl-9'>
                      {/*begin::Card*/}
                      {staffLoading && <ListLoading />}
                      {!staffLoading && !staff?.entities?.length && <NoData view='service' />}
                      {staff?.entities?.map((entity, i) => (
                        <div
                          key={i}
                          className='card card-flush flex-row-fluid flex-lg-row-auto p-6 pb-5 mw-100 cursor-pointer'
                          onClick={() => updateData('staff_id', entity.id, entity, 'date')}
                          style={entity.id === formik.values.staff_id ? {opacity: 0.5} : {}}
                        >
                          {/*begin::Body*/}
                          <div className='card-body text-center'>
                            {/*begin::Food img*/}
                            <img
                              src={
                                entity.image_url
                                  ? process.env.REACT_APP_BUCKET_URL + '/' + entity.image_url
                                  : toAbsoluteUrl(
                                      `/media/svg/avatars/blank${
                                        mode === 'dark' ? '-dark' : ''
                                      }.svg`
                                    )
                              }
                              className='rounded-3 mb-4 w-150px h-150px w-xxl-200px h-xxl-200px'
                              alt=''
                            />
                            {/*end::Food img*/}
                            {/*begin::Info*/}
                            <div className='mb-2'>
                              {/*begin::Title*/}
                              <div className='text-center'>
                                <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-3 fs-xl-1'>
                                  {truncateString(entity.name!, 15)}
                                </span>
                                <span className='text-gray-400 fw-semibold d-block fs-6 mt-n1'>
                                  {entity.title}
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Info*/}
                          </div>
                          {/*end::Body*/}
                        </div>
                      ))}
                      {/*end::Card*/}
                    </div>
                    {/*end::Wrapper*/}
                  </div>
                  {/*end::Tap pane*/}
                  {/*begin::Tap pane*/}
                  <div className='tab-pane fade' id='date'>
                    {/*begin::Wrapper*/}
                    <div className='d-flex flex-wrap d-grid gap-5 gap-xxl-9'>
                      <h3>Select Date and Time</h3>
                      <input
                        placeholder='date'
                        className='form-control form-control-lg'
                        type='date'
                        onChange={(e) => {
                          updateData('date', e.target.value, e.target.value)
                        }}
                      ></input>
                      {availabilityLoading && <ListLoading />}
                      {availabilityFetched && !timeslots.length && <NoData view='staff' />}
                      {timeslots.map((entity, i) => (
                        <div key={i} className='card card-flush flex-row-fluid p-6 pb-5 mw-100'>
                          {/*begin::Body*/}
                          <div className='card-body text-center'>
                            <label
                              className={`btn btn-outline btn-outline-dashed btn-active-light-primary w-100 p-4 ${
                                formik.values.start_time === entity.start ? 'active' : ''
                              }`}
                            >
                              <input
                                type='radio'
                                className='btn-check'
                                onClick={() =>
                                  updateData('start_time', entity.start, entity.start, 'user')
                                }
                              />
                              <span className='fw-bold fs-3'>
                                {dayjs(entity.start).format('HH:mm')} -{' '}
                                {dayjs(entity.end).format('HH:mm')}
                              </span>
                            </label>
                          </div>
                          {/*end::Body*/}
                        </div>
                      ))}
                    </div>
                    {/*end::Wrapper*/}
                  </div>
                  {/*end::Tap pane*/}
                  {/*begin::Tap pane*/}
                  <div className='tab-pane fade' id='user'>
                    {/*begin::Wrapper*/}
                    <div className='row'>
                      <div className='col-md-6 my-2'>
                        <input
                          placeholder='First name'
                          className='form-control form-control-lg'
                          type='text'
                          {...formik.getFieldProps('customer[first_name]')}
                        ></input>
                        {formik.touched.customer?.first_name && formik.errors.customer?.first_name && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.customer?.first_name}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='col-md-6 my-2'>
                        <input
                          placeholder='Last name'
                          className='form-control form-control-lg'
                          type='text'
                          {...formik.getFieldProps('customer[last_name]')}
                        ></input>
                        {formik.touched.customer?.last_name && formik.errors.customer?.last_name && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.customer?.last_name}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='col-md-6 my-2'>
                        <input
                          placeholder='Email address'
                          className='form-control form-control-lg'
                          type='email'
                          {...formik.getFieldProps('customer[email]')}
                        ></input>
                        {formik.touched.customer?.email && formik.errors.customer?.email && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.customer?.email}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='col-md-6 my-2'>
                        <input
                          placeholder='Phone number'
                          className='form-control form-control-lg'
                          type='phone'
                          {...formik.getFieldProps('customer[phone]')}
                        ></input>
                        {formik.touched.customer?.phone && formik.errors.customer?.phone && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.customer?.phone}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='col-md-6 my-2'>
                        <select
                          placeholder='Country'
                          className='form-select form-select-lg'
                          {...formik.getFieldProps('customer[country]')}
                        >
                          <option value=''>-- Select Country --</option>
                          {countries.map((country, i) => (
                            <option value={country.value} key={i}>
                              {country.label}
                            </option>
                          ))}
                        </select>
                        {formik.touched.customer?.country && formik.errors.customer?.country && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.customer?.country}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='col-md-6 my-2'>
                        <input
                          placeholder='State'
                          className='form-control form-control-lg'
                          type='state'
                          {...formik.getFieldProps('customer[state]')}
                        ></input>
                        {formik.touched.customer?.state && formik.errors.customer?.state && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.customer?.state}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='col-md-12 my-2'>
                        <textarea
                          placeholder='Note'
                          className='form-control form-control-lg'
                          {...formik.getFieldProps('description')}
                        ></textarea>
                      </div>
                      <div className='my-5'>
                        <div className='d-flex justify-content-between'>
                          <input
                            placeholder='Promotional Code'
                            className='form-control form-control-lg'
                            type='text'
                            onChange={(e) => setCode(e.target.value)}
                          ></input>
                          {/*begin::Actions*/}
                          <button
                            className='btn btn-primary ms-5 w-25'
                            type='button'
                            onClick={verify}
                            disabled={!code || verifying}
                            data-kt-indicator={verifying ? 'on' : 'off'}
                          >
                            <span className='indicator-label'>Apply</span>
                            <span className='indicator-progress'>
                              {/* Please wait...{' '} */}
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          </button>
                          {/*end::Actions*/}
                        </div>
                      </div>
                      <div className='col-12 my-2'>
                        <div className='card card-flush bg-body' id='kt_pos_form'>
                          {/*begin::Body*/}
                          <div className='card-body pt-0'>
                            {/*begin::Payment Method*/}
                            <div className='m-10'>
                              {/*begin::Title*/}
                              <h1 className='fw-bold text-gray-800 mb-5'>Payment Method</h1>
                              {/*end::Title*/}
                              {/*begin::Radio group*/}
                              <div className='d-flex flex-equal gap-5 gap-xxl-9 px-0 mb-12'>
                                {/*begin::Radio*/}
                                <label
                                  className={`btn bg-light btn-color-gray-600 btn-active-text-gray-800 border border-3 border-gray-100 border-active-primary btn-active-light-primary w-100 px-4 ${
                                    formik.values.payment_type === 'cash' ? 'active' : ''
                                  }`}
                                >
                                  {/*begin::Input*/}
                                  <input
                                    className='btn-check'
                                    type='radio'
                                    onClick={() => formik.setFieldValue('payment_type', 'cash')}
                                  />
                                  {/*end::Input*/}
                                  {/*begin::Icon*/}
                                  <KTSVG
                                    path='/media/icons/duotune/finance/fin010.svg'
                                    className='svg-icon-muted svg-icon-2hx'
                                  />
                                  {/*end::Icon*/}
                                  {/*begin::Title*/}
                                  <span className='fs-7 fw-bold d-block'>Cash</span>
                                  {/*end::Title*/}
                                </label>
                                {/*end::Radio*/}
                                {/*begin::Radio*/}
                                <label
                                  className={`btn bg-light btn-color-gray-600 btn-active-text-gray-800 border border-3 border-gray-100 border-active-primary btn-active-light-primary w-100 px-4 ${
                                    formik.values.payment_type === 'stripe' ? 'active' : ''
                                  }`}
                                >
                                  {/*begin::Input*/}
                                  <input
                                    className='btn-check'
                                    type='radio'
                                    onClick={() => formik.setFieldValue('payment_type', 'stripe')}
                                  />
                                  {/*end::Input*/}
                                  {/*begin::Icon*/}
                                  <KTSVG
                                    path='/media/icons/duotune/finance/fin002.svg'
                                    className='svg-icon-muted svg-icon-2hx'
                                  />
                                  {/*end::Icon*/}
                                  {/*begin::Title*/}
                                  <span className='fs-7 fw-bold d-block'>Stripe</span>
                                  {/*end::Title*/}
                                </label>
                                {/*end::Radio*/}
                                {/*begin::Radio*/}
                                <label
                                  className={`btn bg-light btn-color-gray-600 btn-active-text-gray-800 border border-3 border-gray-100 w-100 px-4 ${
                                    formik.values.payment_type === 'wallet' ? 'active' : ''
                                  }`}
                                  style={{opacity: 0.5}}
                                >
                                  {/*begin::Input*/}
                                  <input
                                    className='btn-check'
                                    type='radio'
                                    onClick={() => formik.setFieldValue('payment_type', 'wallet')}
                                    disabled={true}
                                  />
                                  {/*end::Input*/}
                                  {/*begin::Icon*/}
                                  <KTSVG
                                    path='/media/icons/duotune/finance/fin008.svg'
                                    className='svg-icon-muted svg-icon-2hx'
                                  />
                                  {/*end::Icon*/}
                                  {/*begin::Title*/}
                                  <span className='fs-7 fw-bold d-block'>E-Wallet</span>
                                  {/*end::Title*/}
                                </label>
                                {/*end::Radio*/}
                              </div>
                              {/*end::Radio group*/}
                              {/*begin::Actions*/}
                              <button
                                type='button'
                                onClick={() => formik.handleSubmit()}
                                className='btn btn-primary fs-1 w-100 py-4'
                                disabled={formik.isSubmitting}
                                data-kt-indicator={formik.isSubmitting ? 'on' : 'off'}
                              >
                                <span className='indicator-label'>Proceed to Payment</span>
                                <span className='indicator-progress'>
                                  Please wait...{' '}
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              </button>
                              {/*end::Actions*/}
                            </div>
                            {/*end::Payment Method*/}
                          </div>
                          {/*end: Card Body*/}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*end::Wrapper*/}
                  {/* </div> */}
                  {/*end::Tap pane*/}
                </div>
                {/*end::Tab Content*/}
              </div>
              {/*end: Card Body*/}
            </div>
            {/*end::Pos food*/}
          </div>
          {/*end::Content*/}
          {/*begin::Sidebar*/}
          <div className='flex-row-auto w-xl-425px'>
            {/*begin::Pos order*/}
            <div className='card card-flush bg-body' id='kt_pos_form'>
              {/*begin::Header*/}
              <div className='card-header pt-5'>
                <h3 className='card-title fw-bold text-gray-800 fs-2qx'>Current Order</h3>
                {/*begin::Toolbar*/}
                <div className='card-toolbar'>
                  <button
                    onClick={() => {
                      formik.resetForm({})
                      setSummary({})
                      updateView('location')
                    }}
                    className='btn btn-light-primary fs-4 fw-bold py-4'
                  >
                    Clear All
                  </button>
                </div>
                {/*end::Toolbar*/}
              </div>
              {/*end::Header*/}
              {/*begin::Body*/}
              <div className='card-body pt-0'>
                {/*begin::Table container*/}
                <div className='table-responsive mb-8'>
                  {/*begin::Table*/}
                  <table className='table align-middle gs-0 gy-2 my-0'>
                    {/*begin::Table head*/}
                    <thead>
                      <tr>
                        <th className=''></th>
                        <th className=''></th>
                        <th className=''></th>
                      </tr>
                    </thead>
                    {/*end::Table head*/}
                    {/*begin::Table body*/}
                    <tbody>
                      <tr data-kt-pos-element='item'>
                        <td className='pe-0'>
                          <div className='d-flex align-items-center'>
                            <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 me-1'>
                              {intl.formatMessage({id: 'Location'})}
                            </span>
                          </div>
                        </td>
                        <td className='text-end'>
                          <span className='fw-bold text-primary fs-4'>
                            {summary.location?.name}
                          </span>
                        </td>
                        {summary.location && (
                          <td className='pe-0'>
                            {/*begin::Dialer*/}
                            <div className='position-relative d-flex align-items-center'>
                              {/*begin::Increase control*/}
                              <button
                                onClick={() => updateData('location_id', null, null, 'location')}
                                type='button'
                                className='btn btn-icon btn-sm btn-light btn-icon-gray-400'
                              >
                                {/*begin::Svg Icon | path: icons/duotune/arrows/arr087.svg*/}
                                <span className='svg-icon svg-icon-2x'>
                                  <KTSVG path='/media/icons/duotune/general/gen034.svg' />
                                </span>
                                {/*end::Svg Icon*/}
                              </button>
                              {/*end::Increase control*/}
                            </div>
                            {/*end::Dialer*/}
                          </td>
                        )}
                      </tr>
                      <tr data-kt-pos-element='item'>
                        <td className='pe-0'>
                          <div className='d-flex align-items-center'>
                            <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 me-1'>
                              {intl.formatMessage({id: 'Service'})}
                            </span>
                          </div>
                        </td>
                        <td className='text-end'>
                          <span className='fw-bold text-primary fs-4'>{summary.service?.name}</span>
                        </td>
                        {summary.service && (
                          <td className='pe-0'>
                            {/*begin::Dialer*/}
                            <div className='position-relative d-flex align-items-center'>
                              {/*begin::Increase control*/}
                              <button
                                onClick={() => updateData('service_id', null, null, 'service')}
                                type='button'
                                className='btn btn-icon btn-sm btn-light btn-icon-gray-400'
                              >
                                {/*begin::Svg Icon | path: icons/duotune/arrows/arr087.svg*/}
                                <span className='svg-icon svg-icon-2x'>
                                  <KTSVG path='/media/icons/duotune/general/gen034.svg' />
                                </span>
                                {/*end::Svg Icon*/}
                              </button>
                              {/*end::Increase control*/}
                            </div>
                            {/*end::Dialer*/}
                          </td>
                        )}
                      </tr>
                      <tr data-kt-pos-element='item'>
                        <td className='pe-0'>
                          <div className='d-flex align-items-center'>
                            <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 me-1'>
                              {intl.formatMessage({id: 'Staff'})}
                            </span>
                          </div>
                        </td>
                        <td className='text-end'>
                          <span className='fw-bold text-primary fs-4'>{summary.staff?.name}</span>
                        </td>
                        {summary.staff && (
                          <td className='pe-0'>
                            {/*begin::Dialer*/}
                            <div className='position-relative d-flex align-items-center'>
                              {/*begin::Increase control*/}
                              <button
                                onClick={() => updateData('staff_id', null, null, 'staff')}
                                type='button'
                                className='btn btn-icon btn-sm btn-light btn-icon-gray-400'
                              >
                                {/*begin::Svg Icon | path: icons/duotune/arrows/arr087.svg*/}
                                <span className='svg-icon svg-icon-2x'>
                                  <KTSVG path='/media/icons/duotune/general/gen034.svg' />
                                </span>
                                {/*end::Svg Icon*/}
                              </button>
                              {/*end::Increase control*/}
                            </div>
                            {/*end::Dialer*/}
                          </td>
                        )}
                      </tr>
                      <tr data-kt-pos-element='item'>
                        <td className='pe-0'>
                          <div className='d-flex align-items-center'>
                            <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 me-1'>
                              Duration
                            </span>
                          </div>
                        </td>
                        <td className='text-end'>
                          <span className='fw-bold text-primary fs-4'>
                            {summary.service?.duration ? summary.service?.duration + 'mins' : ''}
                          </span>
                        </td>
                        <td className='pe-0'></td>
                      </tr>
                      <tr data-kt-pos-element='item'>
                        <td className='pe-0'>
                          <div className='d-flex align-items-center'>
                            <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 me-1'>
                              Date
                            </span>
                          </div>
                        </td>
                        <td className='text-end'>
                          <span className='fw-bold text-primary fs-4'>{summary.date}</span>
                        </td>
                        <td className='pe-0'></td>
                      </tr>
                      <tr data-kt-pos-element='item'>
                        <td className='pe-0'>
                          <div className='d-flex align-items-center'>
                            <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 me-1'>
                              Start Time
                            </span>
                          </div>
                        </td>
                        <td className='text-end'>
                          <span className='fw-bold text-primary fs-4'>
                            {summary.start_time ? dayjs(summary.start_time).format('hh:mm a') : ''}
                          </span>
                        </td>
                        <td className='pe-0'></td>
                      </tr>
                    </tbody>
                    {/*end::Table body*/}
                  </table>
                  {/*end::Table*/}
                </div>
                {/*end::Table container*/}
                {/*begin::Summary*/}
                <div className='d-flex flex-stack bg-success rounded-3 p-6 mb-11'>
                  {/*begin::Content*/}
                  <div className='fs-6 fw-bold text-white'>
                    <span className='d-block lh-1 mb-2'>Subtotal</span>
                    <span className='d-block mb-2'>Discounts</span>
                    <span className='d-block mb-9'>
                      {tax ? tax.name : 'Tax'}({tax?.percentage || 0}%)
                    </span>
                    <span className='d-block fs-2qx lh-1'>Total</span>
                  </div>
                  {/*end::Content*/}
                  {/*begin::Content*/}
                  <div className='fs-6 fw-bold text-white text-end'>
                    <span className='d-block lh-1 mb-2'>
                      <GetCurrency value={summary.service?.charge} />
                    </span>
                    <span className='d-block mb-2'>
                      -<GetCurrency value={charges.discount} />
                    </span>
                    <span className='d-block mb-9'>
                      <GetCurrency value={charges.tax} />
                    </span>
                    <span className='d-block fs-2qx lh-1'>
                      <GetCurrency value={charges.gross} />
                    </span>
                  </div>
                  {/*end::Content*/}
                </div>
                {/*end::Summary*/}
              </div>
              {/*end: Card Body*/}
            </div>
            {/*end::Pos order*/}
          </div>
          {/*end::Sidebar*/}
        </div>
        {/*end::Layout*/}
      </div>
      {/*end::Content container*/}
    </div>
  )
}
